import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Modal, Button } from 'hljd'
import styles from './style.module.less'
import { getMerchantInfo } from '@util'
import { PRIVILEGE_NORMAL_ID, PRIVILEGE_STORE_ID } from '@constant'
import { Auth } from '@common/Auth'
import store from './store'
import { dGet } from '@core/utils'

@Auth({ role: [PRIVILEGE_NORMAL_ID, PRIVILEGE_STORE_ID] })
@observer
export default class extends Component {
  render() {
    const { isShow_authModal, toggleAuthModal, linkToAuth } = store
    const info = getMerchantInfo()
    const tip = dGet(info, 'frontpage_config.company_certify.tip')
    const btnText = dGet(info, 'frontpage_config.company_certify.button')

    return (
      <Modal
        visible={isShow_authModal}
        onCancel={toggleAuthModal}
        title="重要通知"
        closable={false}
        maskClosable={false}
        footer={false}
        keyboard={false}
      >
        <div className={styles.noticeWrap}>
          <p className={styles.content}>{tip}</p>

          <div className="text-right">
            <Button type="primary " onClick={linkToAuth}>
              {btnText}
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
}
